type Props = {
  name: IconName;
  title?: string;
  size?: number;
  color?: string;
};

export const Icon: React.FC<Props> = ({ name, title, size = 24, color }) => {
  return (
    <svg width={size} height={size} style={{ color: color }}>
      {title != null && <title>{title}</title>}
      <use xlinkHref={`#${name}`} />
    </svg>
  );
};

type LogoProps = {
  name: IconName;
  width: number;
  height: number;
};

export const Logo: React.FC<LogoProps> = ({ name, width, height }) => {
  return (
    <svg width={width} height={height}>
      <use xlinkHref={`#${name}`} />
    </svg>
  );
};
